export { ko } from '@payloadcms/translations/languages/ko'
